import { FC, useMemo } from 'react'
import tw from 'tailwind-styled-components'
import { useTranslation } from 'next-i18next'
import { NestedListItem } from './NestedListItem'
import { CloseButton } from '../../../CloseButton'
import { ForestGroupTitle } from '@foros-fe/graphql'

type Props = {
  onClose(): void
  className?: string
}

const Container = tw.div`
  absolute
  top-0
  bottom-0
  left-0
  w-80
  bg-white
  z-[200]
  overflow-scroll
`
const Line = tw.div`
  border-b-2
  border-gray-400
  bg-white
  h-9
  flex-1
  flex
  justify-between
  items-center
  px-2
  font-semibold
`
const Box = tw.div`border-r border-b-2 border-gray-400 w-[37px]`

export const forestGroupTitles = Object.values(ForestGroupTitle).filter((value) => value !== 'II')

export const SideMenu: FC<Props> = ({ onClose, className }) => {
  const { t } = useTranslation('common')
  const items = useMemo(
    () => [
      { title: t('map.cadastralPlots'), id: 'cadastralPlots' },
      { title: t('map.taxonomicPlots'), id: 'taxonomicPlots' },
      {
        title: t('map.forestGroups'),
        id: 'forestGroups',
        items: forestGroupTitles.map((title) => ({ id: title, title })),
      },
      { title: t('map.forestHabitats'), id: 'forestHabitats' },
    ],
    [t]
  )

  return (
    <Container className={className}>
      <div className='flex flex-col'>
        <div className='flex'>
          <Box />
          <Line>
            <span>{t('map.layers')}</span>
            <CloseButton onClick={onClose} />
          </Line>
        </div>
        {items.map((item) => (
          <NestedListItem key={item.id} {...item} />
        ))}
      </div>
    </Container>
  )
}
